import { createGlobalStyle } from 'styled-components';
import './iconFont.scss';
import RubikLightOtf from '../fonts/Rubik-Light.otf';
import RubikLightEot from '../fonts/Rubik-Light.eot';
import RubikLightTtf from '../fonts/Rubik-Light.ttf';
import RubikLightWoof from '../fonts/Rubik-Light.woff';

import RubikMediumOtf from '../fonts/Rubik-Medium.otf';
import RubikMediumEot from '../fonts/Rubik-Medium.eot';
import RubikMediumTtf from '../fonts/Rubik-Medium.ttf';
import RubikMediumWoof from '../fonts/Rubik-Medium.woff';

import RubikRegularOtf from '../fonts/Rubik-Regular.otf';
import RubikRegularEot from '../fonts/Rubik-Regular.eot';
import RubikRegularTtf from '../fonts/Rubik-Regular.ttf';
import RubikRegularWoof from '../fonts/Rubik-Regular.woff';

import RubikBoldOtf from '../fonts/Rubik-Bold.otf';
import RubikBoldEot from '../fonts/Rubik-Bold.eot';
import RubikBoldTtf from '../fonts/Rubik-Bold.ttf';
import RubikBoldWoof from '../fonts/Rubik-Bold.woff';
import { colors } from '../../components/colors';

const GlobalStyle = createGlobalStyle`
::-webkit-scrollbar-track {
    box-shadow: none;
  -webkit-box-shadow: none;
  border-radius: 10px;
  background: none;
}

::-webkit-scrollbar {
  width: 12px;
  height: 12px;
  background: none;
}

::-webkit-scrollbar-thumb {
  border-radius: 14px;
  box-shadow: none;
  -webkit-box-shadow: none;
  background-color: ${colors.ScrollbarColor};
}
::-webkit-file-upload-button {
  cursor: pointer;
}
input[type=file] {
  cursor:pointer;
}
*:focus{
  outline: none;
}
@font-face {
    font-family: 'RubikLight';
    src: local('☺'), local('Rubik-Light.eot'),
    url(${RubikLightOtf}) format('otf'),
    url(${RubikLightEot}) format('eot'),
    url(${RubikLightTtf}) format('truetype'),
    url(${RubikLightWoof}) format('woff');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'RubikMedium';
    src: local('☺'), local('Rubik-Medium.eot'),
    url(${RubikMediumOtf}) format('otf'),
    url(${RubikMediumEot}) format('eot'),
    url(${RubikMediumTtf}) format('truetype'),
    url(${RubikMediumWoof}) format('woff');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'RubikRegular';
    src: local('☺'), local('Rubik-Regular.eot'),
    url(${RubikRegularOtf}) format('otf'),
    url(${RubikRegularEot}) format('eot'),
    url(${RubikRegularTtf}) format('truetype'),
    url(${RubikRegularWoof}) format('woff');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'RubikBold';
    src: local('☺'), local('Rubik-Bold.eot'),
    url(${RubikBoldOtf}) format('otf'),
    url(${RubikBoldEot}) format('eot'),
    url(${RubikBoldTtf}) format('truetype'),
    url(${RubikBoldWoof}) format('woff');
    font-weight: normal;
    font-style: normal;
}

::-webkit-input-placeholder {
  color: ${colors.PlaceholderColor};
  font-family: 'RubikRegular';
  font-size: 14px;
}
::-moz-placeholder {
  color: ${colors.PlaceholderColor};
  font-family: 'RubikRegular';
  font-size: 14px;
}
:-ms-input-placeholder {
  color: ${colors.PlaceholderColor};
  font-family: 'RubikRegular';
  font-size: 14px;
}
:-moz-placeholder {
  color: ${colors.PlaceholderColor};
  font-family: 'RubikRegular';
  font-size: 14px;
}

html {
    position: relative;
    min-height: 100%;
    line-height: 1.15;
    width: 100%;
    margin: 0;
    padding: 0;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    font-family: 'RubikRegular', sans-serif;
    scrollbar-color: ${colors.ScrollbarColor};
	  scrollbar-width: auto;
  }

  body {
    min-height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    letter-spacing: normal;
    line-height: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'RubikRegular', sans-serif;
    scrollbar-color: ${colors.ScrollbarColor};
    scrollbar-width: auto;
    font-size: 14px;
    background:#f9f9f9;
  }
 canvas{
      width:100% !important;
      height:auto !important;
  }

  div,
  span,
  p,
  label,
  h1,
  h2,
  h3,
  h4,
  h5,
  input,
  select,
  textarea,
  button {
    margin: 0;
    font-family: 'RubikRegular', sans-serif;
    overflow-wrap: break-word;
    font-weight: normal;
  }
button{
  cursor: pointer;
  text-decoration: none!important;
}
  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  * {
    -webkit-overflow-scrolling: touch;
  }

  :after,
  :before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  :focus {
    outline: 0 !important;
  }
  input[type="password"]{
    padding-top: 19px;
    font-size: 16px;
    font-family: 'RubikBold';
    letter-spacing: .5px;
  }
  a{
    color: ${colors.BlueBase};
    text-decoration: underline;
    font-size: 14px;
    line-height: 22px;
    cursor:pointer;
    transition: ease-in all 0.4s;
    word-break: break-all;
    text-decoration: none!important;
    &:hover {
      text-decoration: none;
      color: ${colors.BlueLight};
    }
    button{
      cursor: pointer;
      text-decoration: none;
    }
  }
  b,
  strong {
    font-weight: 900;
  }

  @media (min-width: 1366px) {
    .container {
      max-width: 1280px;
    }
  }

  ::selection {
    color:  ${colors.White};
    background-color: ${colors.Black};
  }

  ::-moz-selection {
    color:  ${colors.White};
    background-color: ${colors.Black};
  }
  .react-datepicker-wrapper {
    display: inline-block;
    padding: 0;
    border: 0;
    width:100%;
  }

  /* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 500px;
  background-color: rgb(35, 59, 88);
  color: #fff;
  text-align: center;
  padding: 10px ;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 999;
  bottom: 125%;
  left: 50%;
  border-style: solid;
  border: 1px solid #000;
  // margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border: 1px solid #000;
  // border-color: #000 transparent transparent transparent;
  display:none;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
`;

export default GlobalStyle;
